import { render } from "./TermesInvest.vue?vue&type=template&id=626eefba"
import script from "./TermesInvest.vue?vue&type=script&lang=js"
export * from "./TermesInvest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__